import { motion } from "framer-motion";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { LogoStyleContext } from "../context/LogoStyleContext";

import { MenuButton } from "./menu/MenuButton";
import { Box } from "./Box";
import { Portal } from "./Portal";
import { easings } from "../styles/utils";

import { ReactComponent as LogoMain } from "../assets/svg/boots-logo.svg";
import { MenuOpenContext } from "../context/MenuOpenContext";

const Wrapper = styled(motion.div)`
  position: relative;
  z-index: 10;
`;

const LogoPosition = styled(Box)`
  position: absolute;
`;

const LogoSizer = styled(Box)`
  svg {
    height: 100%;
    width: auto;
  }
`;

const MenuButtonPosition = styled(Box)`
  position: fixed;
  z-index: 20;
`;

const wrapperVariants = {
  initial: { opacity: 0, y: -10 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { delay: 0.6, duration: 0.8, ease: easings.easeOutCubic },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: { delay: 0.2, duration: 0.8, ease: easings.easeOutCubic },
  },
};

export const Header: React.FC = () => {
  const { logoStyle } = useContext(LogoStyleContext);
  const { menuOpen, setMenuOpen } = useContext(MenuOpenContext);
  const location = useLocation();

  const isHome = location.pathname === "/";

  return (
    <Wrapper>
      <LogoPosition top={[3, null, 4]} left={[3, null, 4]}>
        <motion.div
          variants={wrapperVariants}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          {!isHome ? (
            <Link to="/">
              <LogoSizer
                color={logoStyle === "light" ? "white" : "blueDark"}
                height={["48px", null, "64px"]}
              >
                <LogoMain />
              </LogoSizer>
            </Link>
          ) : (
            <LogoSizer
              color={logoStyle === "light" ? "white" : "blueDark"}
              height={["48px", null, "64px"]}
            >
              <LogoMain />
            </LogoSizer>
          )}
        </motion.div>
      </LogoPosition>
      <Portal>
        <MenuButtonPosition top={[3, null, 4]} right={[3, null, 4]}>
          <motion.div
            variants={wrapperVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <MenuButton
              onClick={() => setMenuOpen(!menuOpen)}
              open={menuOpen}
            />
          </motion.div>
        </MenuButtonPosition>
      </Portal>
    </Wrapper>
  );
};
